import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Row } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import GenericBrowsePageResizeHelper from "../components/common/GenericBrowsePageResizeHelper";
import Loader from "../components/common/Loader";
import GenericTeletabberGallery from "../components/gallery/GenericTeletabberGallery";
import TitleNavbar from "../components/navbars/TitleNavbar";
import ToolbarSelector from "../components/navbars/ToolbarSelector";

interface IParams {
  presentationId: string;
}

const RepositoryBrowsePage: React.FC<RouteComponentProps<IParams>> = ({
  match,
  location,
  history,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { loadPresentationDetails } = rootStore.presentationStore;
  const { currentBrowsePageContent, selectedLanguageId, resetBrowsePage } =
    rootStore.commonStore;
  const { attendingMeeting } = rootStore.playerStore;
  const { errorUrl } = rootStore.tenantStore;
  const { setSourceId } = rootStore.meetingStore;
  const { destroyZwibblerContext } = rootStore.zwibblerStore;
  const [galleryStartingPage, setGalleryStartingPage] = useState(0);

  useEffect(() => {
    const intPresentationId = parseInt(match.params.presentationId);
    if (intPresentationId) {
      if (attendingMeeting) setSourceId(attendingMeeting.id);
      else setSourceId(null);

      const urlParams = new URLSearchParams(location.search);
      //gallery page
      const page = urlParams.get("pag") ?? "";
      let intPage = parseInt(page);
      setGalleryStartingPage(intPage);
      loadPresentationDetails(intPresentationId)
        .then()
        .catch(() => history.push(errorUrl));
    } else history.push(errorUrl);

    return () => {
      resetBrowsePage();
      destroyZwibblerContext();
    };
  }, [
    location.search,
    match.params.presentationId,
    errorUrl,
    history,
    setSourceId,
    loadPresentationDetails,
    attendingMeeting,
    selectedLanguageId,
    resetBrowsePage,
    destroyZwibblerContext,
  ]);

  if (!currentBrowsePageContent) return <Loader />;

  return (
    <>
      <GenericBrowsePageResizeHelper />
      <Row>
        <TitleNavbar title={currentBrowsePageContent.title.document} />
      </Row>
      <Row>
        <ToolbarSelector
          items={currentBrowsePageContent.items}
          isSidebarOpen={true}
          stickyButton="share"
        />
      </Row>
      <Row>
        <GenericTeletabberGallery
          items={currentBrowsePageContent.items}
          startingPage={galleryStartingPage}
        />
      </Row>
    </>
  );
};

export default observer(RepositoryBrowsePage);
